// extracted by css-extract-rspack-plugin
export default {"image":"image-_D5NBu","pdf":"pdf-avwRJ1"};